import React from "react"
import {UxCTA as CTA} from "@next/ux-cta"
import {StyledBox, StyledContainer} from "./component"
import {removeDeptFromSessionStorage} from "../../../../utils/removeDeptFromSessionStorage"

export const ClubCheckout = props => {
    const {enable} = props
    return (
        <StyledContainer
            data-testid="header-adaptive-checkout"
            className="header-adaptive-checkout"
            xxlBreakpointEnabled={props.xxlBreakpointEnabled}
        >
            <StyledBox display={{xs: "none", md: "block"}}>
                <CTA
                    {...props}
                    color="primary"
                    disabled={!enable}
                    state={enable ? "enabled" : "disabled"}
                    variant="contained"
                    size="large"
                    rel="nofollow"
                    onClick={removeDeptFromSessionStorage}
                />
            </StyledBox>
        </StyledContainer>
    )
}

export default ClubCheckout
